// Bank-scoped localStorage helpers
// Keys are stored as: bank_<bankKey>_<key>
// Fallback: when reading, if banked key is missing, read legacy unscoped key

const normalizeBankKey = (bank: string): string => {
  const key = (bank || "").toString().trim().toLowerCase();
  return key || "default";
};

const makeBankedKey = (bank: string, key: string): string => {
  return `bank_${normalizeBankKey(bank)}_${key}`;
};

export const getBankedItem = (bank: string, key: string): string | null => {
  try {
    const value = localStorage.getItem(makeBankedKey(bank, key));
    if (value !== null && typeof value !== "undefined") return value;
    // Fallback to legacy, unscoped
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

export const setBankedItem = (bank: string, key: string, value: string): void => {
  try {
    localStorage.setItem(makeBankedKey(bank, key), value);
  } catch (e) {
    // no-op
  }
};

export const removeBankedItem = (bank: string, key: string): void => {
  try {
    localStorage.removeItem(makeBankedKey(bank, key));
  } catch (e) {
    // no-op
  }
};

export const clearBankScope = (bank: string): void => {
  try {
    const prefix = `bank_${normalizeBankKey(bank)}_`;
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(prefix)) {
        keysToRemove.push(k);
      }
    }
    keysToRemove.forEach((k) => localStorage.removeItem(k));
  } catch (e) {
    // no-op
  }
};

export const makeScopedKey = (bank: string, key: string): string =>
  makeBankedKey(bank, key);
